import React from 'react'

import { DefaultLayout } from 'layouts/DefaultLayout'
import { Wrapper } from '@farewill/ui'
import styled from 'styled-components'
import { CustomerReports } from 'components/CustomerReports'

const StyledWrapper = styled(Wrapper)`
  width: 100%;
`

export const Reports = (): React.ReactElement => {
  return (
    <DefaultLayout>
      <StyledWrapper container>
        <CustomerReports />
      </StyledWrapper>
    </DefaultLayout>
  )
}
